// File: src/utils/mixerApi.js
// -------------------------------------------------------------
// Thin wrapper around every `/mixer/*` back-end route.
// All requests automatically include the proper JWT header
// thanks to src/utils/axiosGlobal.js interceptors.
// -------------------------------------------------------------
import axios from './axiosGlobal';

/* ============================================================
 * 1) ADMIN-ONLY CALLS
 * ============================================================ */

/** Create a *draft* mixer event (not yet live). */
export const createMixerEvent = (payload) =>
  axios.post('/mixer/events', payload);

/** Publish a draft: locks settings, generates rounds & quiz, starts scheduler. */
export const publishMixerEvent = (eventId) =>
  axios.patch(`/mixer/events/${eventId}/publish`);

/** Get the post-event metrics / colour-match stats. */
export const getMixerReport = (eventId) =>
  axios.get(`/mixer/events/${eventId}/report`);

/** Door-staff or QR-scan check-in. */
export const checkInAttendee = (eventId, userId) =>
  axios.post(`/mixer/events/${eventId}/checkin`, { userId });

/* ============================================================
 * 2) GUEST-SIDE CALLS
 * ============================================================ */

/** Pull the personalised quiz (trait items only). */
export const fetchQuiz = (eventId, userId) =>
  axios.get(`/mixer/events/${eventId}/quiz`, { params: { userId } });

/** Submit answers => saves MixerScore docs server-side.
    answers = [{ axis, qId, value }, … ] */
export const submitQuizAnswers = (eventId, userId, answers) =>
  axios.post(`/mixer/events/${eventId}/answers`, { userId, answers });

/* ============================================================
 * 3) Convenience — bundle exports
 * ============================================================ */
export default {
  createMixerEvent,
  publishMixerEvent,
  getMixerReport,
  checkInAttendee,
  fetchQuiz,
  submitQuizAnswers,
};
